<section class="section-hero">
  <div class="section-overlay"></div>

  <div class="section-container">
    <!-- Sección de Texto -->
    <div class="section-text">
      <h1>Pantalla de administrador de Ecoturismo</h1>
    </div>

    <!-- Carrusel -->
    <div class="carousel">
      <div #slider class="carousel-track">
        <img *ngFor="let img of images" [src]="img" class="carousel-img">
      </div>

      <!-- Botones -->
      <button (click)="prevSlide()" class="carousel-btn carousel-btn-left">&#10094;</button>
      <button (click)="nextSlide()" class="carousel-btn carousel-btn-right">&#10095;</button>
    </div>
  </div>
</section>
